<template>
  <div class="container">
    <div class="user">
      <div class="user-info">
        <div class="hd">
          <img :src="user.avatar" alt="">
        </div>
        <div class="name">
          <div class="bd">{{user.nickname}} (uid: {{user.id}})</div>
          <div class="bd">{{user.realname}}</div>
        </div>
        <div class="ft">分销商</div>
      </div>
    </div>
    <div class="dashboard">
      <div class="hd">
        <div class="title">累计收益(元)</div>
        <div class="history" @click="toHistory">
          历史明细
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="bd">
        <span class="price">{{user.totalDistributeAmount}}</span>
        <div class="withdrawBtn" @click="toWithDraw">去提现</div>
      </div>
      <div class="ft">
        <div class="item">
          <div class="desc">今日收益(元)</div>
          <div class="title">{{user.todayIncomeAmount}}</div>
        </div>
        <div class="item">
          <div class="desc">昨日收益(元)</div>
          <div class="title">{{user.yesterdayIncomeAmount}}</div>
        </div>
        <div class="item">
          <div class="desc">账户金额(元)</div>
          <div class="title">{{user.validWithdrawAmount}}</div>
        </div>
      </div>
    </div>
    <div class="mysubjects">
      <div class="mysubjects-title">
        <div class="bd">推广课程</div>
        <!-- <div class="ft">如何推广 <van-icon name="question-o" /></div> -->
      </div>
      <div class="subject" v-for="(item, index) in subjects" :key="index" @click="showShareBar(item)">
        <div class="hd">
          <img :src="item.smallLogoImg" alt="">
        </div>
        <div class="bd">
          <div class="title van-ellipsis">{{item.title}}</div>
          <div class="desc van-ellipsis">{{item.desc}}</div>
          <div class="price">拼团价：￥{{item.groupPrice}}</div>
        </div>
        <div class="ft">
          <div class="btn">立即推广</div>
          <div class="bonus">最高可赚：¥{{item.distributeAmount}}</div>
        </div>
      </div>
    </div>
    <Poster :show="showPosterPopup" :posterData="posterData" @close="showPosterPopup=false" />
    <van-popup class="shareBarPopup" v-model="showShareBarPopup" position="bottom">
      <div class="popup-bd">
        <div class="popup-item" @click="share">
          <img src="@/assets/icons/wechat.png" alt="">
          <p>分享微信</p>
        </div>
        <div class="popup-item" @click="createPoster">
          <img src="@/assets/icons/poster.png" alt="">
          <p>生成海报</p>
        </div>
        <div class="popup-item" @click="createQrcode">
          <img src="@/assets/icons/qr.png" alt="">
          <p>二维码</p>
        </div>
      </div>
      <div class="popup-ft van-hairline--top" @click="showShareBarPopup = false">取消</div>
    </van-popup>
    <van-popup class="qrcodePopup" v-model="showQrPopup" :close-on-click-overlay="false">
      <div class="close">
        <van-icon name="close" color="#fff" size="36" @click="showQrPopup=false" />
      </div>
      <div class="box ignore">
        <div class="loading ignore" v-if="qrloading">
          <van-loading />
        </div>
        <div class="qrcode ignore" ref="qrcode">
          <img :src="qrcode" alt="">
        </div>
        <div ref="canvasqr" style="display: none;"></div>
      </div>
      <div class="text">长按图片保存至相册</div>
    </van-popup>
    <!-- 提现弹窗提醒 -->
    <van-popup class="modal" v-model="showWithDrawPopup" :close-on-click-overlay="true">
      <div class="modal-bd">
        <div class="modal-bd__title">{{validWithdrawAmount === 5000 ? '是否提现5000元到微信零钱' : `是否全部(${validWithdrawAmount}元)提现到微信零钱`}}</div>
        <div class="modal-bt__desc" v-if="validWithdrawAmount === 5000">每次最多可提现金额为5000元</div>
      </div>
      <div class="modal-ft">
        <div class="modal-ft__btn-primary" @click="withdrawConfirm">确定</div>
        <div class="modal-ft__btn-default" @click="showWithDrawPopup=false">取消</div>
      </div>
    </van-popup>
    <SharePopup :show="showSharePopup" :text="currentSubject ? currentSubject.shareTitle : ''" @close="showSharePopup=false" />
    <!-- 底部导航菜单 -->
    <Tabbar v-if="user" :isDistributor="user.isDistributor" />
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import Tabbar from '@/components/Tabbar'
import { getDistributorInfo, withDraw } from './query.gql'
import Poster from '@/components/Poster'
import SharePopup from '@/components/SharePopup'
export default {
  name: 'distributor',
  data() {
    return {
      user: null,
      subjects: [],
      showPosterPopup: false,
      showShareBarPopup: false,
      showSharePopup: false,
      showWithDrawPopup: false,
      showQrPopup: false,
      currentSubject: null,
      posterData: null,
      qrloading: false,
      qrcode: ''
    }
  },
  components: {
    Poster,
    Tabbar,
    SharePopup
  },
  computed: {
    validWithdrawAmount() {
      return this.user.validWithdrawAmount > 5000 ? 5000 : this.user.validWithdrawAmount
    }
  },
  methods: {
    loadData() {
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getDistributorInfo,
        fetchPolicy: 'no-cache'
      }).then(res => {
        console.log(res)
        self.user = res.data.profile
        if (!self.user.isDistributor) {
          self.$router.replace({
            name: 'profit'
          })
        }
        self.subjects = res.data.subjects.nodes
        self.$toast.clear()
        // self.$zhuge.identify(self.user.id, {
        //   name: self.user.nickname,
        //   avatar: self.user.avatar
        // })
      }).catch(err => {
        console.error('page：distributor/index。请求getDistributorInfo报错', err)
        self.$toast.clear()
      })
    },
    showShareBar(item) {
      this.currentSubject = item
      this.showShareBarPopup = true
    },
    createPoster() {
      this.posterData = {
        user: {
          avatar: this.user.avatar,
          nickname: this.user.nickname
        },
        posterTplImg: this.currentSubject.posterTplImg,
        wxShareLink: `${window.location.origin}/?#/subject?id=${this.currentSubject.id}&invitationCode=${this.user.invitationCode}`
      }
      this.showPosterPopup = true
      this.showShareBarPopup = false
    },
    async share() {
      // 设置分享
      let wxShareLink = `${window.location.origin}/?#/subject?id=${this.currentSubject.id}&invitationCode=${this.user.invitationCode}`
      let num = Math.floor(Math.random() * 11) + 10
      let param = {
        title: `${num}人正在拼→${this.currentSubject.shareTitle}`,
        imgUrl: this.currentSubject.smallLogoImg,
        desc: this.currentSubject.shareContent,
        link: wxShareLink
      }
      console.log('开始设置分享参数', param)
      await this.wechatShare(param)
      this.showSharePopup = true
      this.showShareBarPopup = false
    },
    createQrcode() {
      this.showQrPopup = true
      this.showShareBarPopup = false
      this.qrloading = true
      setTimeout(() => {
        let wxShareLink = `${window.location.origin}/?#/subject?id=${this.currentSubject.id}&invitationCode=${this.user.invitationCode}`
        // 生成二维码
        const qrcodeImgEl = this.$refs.canvasqr
        console.log(qrcodeImgEl)
        qrcodeImgEl.innerHTML = ''
        let qrcode = new QRCode(qrcodeImgEl, {
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
        qrcode.makeCode(wxShareLink)
        let canvas = document.getElementsByTagName('canvas')[0]
        this.qrcode = canvas.toDataURL('image/png')
        this.qrloading = false
      }, 500)
    },
    toHistory() {
      this.$router.push({
        name: 'distributorHistory'
      })
    },
    toWithDraw() {
      if (this.validWithdrawAmount < 1) {
        this.$toast('可提现金额小于1元，不可提现')
        return
      }
      this.showWithDrawPopup = true
    },
    withdrawConfirm() {
      // 确认提现
      const self = this
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '提交中'
      })
      self.$apollo.mutate({
        mutation: withDraw,
        variables: {
          amount: self.validWithdrawAmount
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.$toast.clear()
        self.showWithDrawPopup = false
        if (res.data.withdrawRequest.withdrawLog) {
          self.$dialog.alert({
            title: '申请提现成功',
            message: `已申请提现${self.validWithdrawAmount}元，剩余${self.user.validWithdrawAmount - self.validWithdrawAmount}元，奖学金在1-2个工作日内放入您的微信零钱中。`,
            confirmButtonText: '确定',
            confirmButtonColor: '#E75E3D'
          })
          self.loadData()
        } else {
          self.$dialog.alert({
            title: '申请提现失败',
            message: res.data.withdrawRequest.errors[0]
          })
        }
      }).catch(err => {
        self.$toast.clear()
        self.$toast('请求出错，请重试')
        console.error('page：distributor/index。请求withDraw报错', err)
      })
    }
  },
  async mounted() {
    await this.weixinAuth()
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
  .container{
    .user{
      height: 100px;
      padding: 15px;
      box-sizing: border-box;
      background: url('~@/assets/icons/distributor-bg.png') no-repeat center center;
      background-size: cover;
      .user-info{
        display: flex;
        align-items: center;
        .hd{
          margin-right: 15px;
          img{
            width: 40px;
            height: 40px;
            border-radius: 20px;
          }
        }
        .name{
          flex: 1;
          display: flex;
          align-items: left;
          flex-direction: column;
        }
        .bd{
          flex: 1;
          color: #fff;
          font-size: 17px;
          font-weight: bold;
        }
        .ft{
          font-size: 11px;
          color: #fff;
          line-height: 20px;
          padding: 0 10px;
          border-radius: 10px;
          border: 1px solid #fff;
        }
      }
    }
    .dashboard{
      margin: 15px;
      padding: 15px;
      background: #fff;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, .1);
      position: relative;
      top: -45px;
      .hd{
        display: flex;
        align-items: center;
        .title{
          flex: 1;
          color: #333;
          font-size: 13px;
          font-weight: bold;
        }
        .history{
          color: #999;
          font-size: 12px;
          display: flex;
          align-items: center;
          .van-icon{
            margin-left: 6px;
          }
        }
      }
      .bd{
        padding: 20px 0;
        display: flex;
        align-items: center;
        .price{
          color: #EB5729;
          font-size: 24px;
          font-weight: bold;
          flex: 1;
        }
        .withdrawBtn {
          background: #EB562B;
          line-height: 25px;
          border-radius: 25px;
          color: #fff;
          font-size: 14px;
          padding: 0 18px;
          margin-left: 10px;
          height: 25px;
        }
      }
      .ft{
        display: flex;
        align-items: center;
        .item{
          flex: 1;
          .title{
            font-size: 14px;
            color: #333;
            font-weight: bold;
            padding-top: 8px;
          }
          .desc{
            color: #999;
            font-size: 12px;
          }
        }
      }
    }
    .mysubjects{
      margin: 15px 15px 45px;
      position: relative;
      top: -30px;
      .mysubjects-title{
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        .bd{
          flex: 1;
          color: #333;
          font-size: 15px;
          font-weight: bold;
        }
        .ft{
          color: #999;
          font-size: 12px;
          display: flex;
          align-items: center;
          .van-icon{
            margin-left: 6px;
            font-size: 14px;
          }
        }
      }
      .subject{
        background: #fff;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        .hd{
          margin-right: 15px;
          img{
            width: 80px;
            height: 80px;
            border-radius: 5px;
          }
        }
        .bd{
          flex: 1;
          .title{
            font-size: 15px;
            color: #333;
            font-weight: bold;
            width: 140px;
            line-height: 21px;
          }
          .desc{
            padding-top: 4px;
            font-size: 12px;
            color: #999;
            width: 140px;
          }
          .price{
            padding-top: 8px;
            color: #333;
            font-size: 13px;
          }
        }
        .ft{
          margin-left: 10px;
          .btn{
            background: #EB5729;
            font-size: 13px;
            color: #fff;
            height: 25px;
            line-height: 25px;
            width: 56px;
            padding: 0 12px;
            border-radius: 12.5px;
            margin: 0 auto;
          }
          .bonus{
            color: #EB5729;
            padding-top: 8px;
            font-size: 13px;
            font-weight: bold;
            text-align: center;
          }
        }
      }
    }
    .van-popup.shareBarPopup{
      .popup-bd{
        display: flex;
        padding: 20px;
        .popup-item{
          flex: 1;
          img{
            width: 50px;
            height: 50px;
            display: block;
            margin: 0 auto;
          }
          p{
            font-size: 11px;
            color: #999;
            padding-top: 6px;
            line-height: 15px;
            text-align: center;
          }
        }
      }
      .popup-ft{
        height: 49px;
        line-height: 49px;
        font-size: 13px;
        color: #666;
        text-align: center;
      }
    }
    .van-popup.qrcodePopup{
      background: none;
      .close{
        padding-bottom: 20px;
        text-align: right;
      }
      .box.ignore{
        width: 240px;
        height: 240px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
        border-radius: 10px;
        background: #fff;
        .loading.ignore{
          width: 240px;
          height: 240px;
          position: absolute;
          background: #fff;
          left: 0;
          top: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .text{
        color: #fff;
        text-align: center;
        font-size: 16px;
        padding-top: 20px;
      }
    }
    .modal{
      width: 300px;
      border-radius: 5px;
      background: #fff;
      padding: 20px;
      box-sizing: border-box;
      .modal-bd{
        font-size: 18px;
        color: #000;
        text-align: center;
        font-weight: 600;
        padding: 17.5px 0 32px;
      }
      .modal-ft{
        padding: 0 17.5px;
        display: flex;
        justify-content: space-around;
        .modal-ft__btn-primary, .modal-ft__btn-default{
          flex: 1;
          border-radius: 5px;
          font-size: 15px;
          color: #fff;
          text-align: center;
          line-height: 40px;
          font-weight: 500;
        }
        .modal-ft__btn-primary{
          background: #E75E3D;
        }
        .modal-ft__btn-default{
          background: #F09E38;
          margin-left: 25px;
        }
      }
    }
  }
</style>
